import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useEditorContext } from '../context/EditorContext';
import { Palette } from '../components/canvas/Palette';
import {
  Canvas,
  useUndo,
  DrawMode,
  DrawTool,
  ColorBitMapPreview,
  bitMap2Base64,
} from '@/src/components/canvas';
import {
  Switch,
  Radio,
  Button,
  Modal,
  message,
} from 'antd';
import { Color } from '@/src/components/canvas/bitmap';
import { useCopyToClipboard } from 'react-use';

export function ToolBar() {
  const {
    Container,
    InlineBlock
  } = S;
  const {
    options,
    colorBitMaps,
    activeBitMapID,
  } = useEditorContext();
  const [visible, setVisible] = useState<boolean>(false);
  const handleCanvasOperationFinish = useUndo({
    onBitMapChange: map => colorBitMaps.updateById(activeBitMapID, {
      ...colorBitMaps.table.entries[activeBitMapID],
      map,
    })
  });
  const [_, copy] = useCopyToClipboard();
  return (
    <Container>
      <InlineBlock>
        <Button size="small" type="primary" onClick={() => {
          const activeBitMap = colorBitMaps.table.entries[activeBitMapID];
          handleCanvasOperationFinish(activeBitMap.map);
          colorBitMaps.updateById(
            activeBitMapID,
            {
              ...activeBitMap,
              map: activeBitMap.map.fill(Color.none),
            });
        }}>清空</Button>
      </InlineBlock>
      <InlineBlock>
        <Radio.Group size="small" value={options.get.tool} onChange={e => options.set.tool(e.target.value)} buttonStyle="solid">
          <Radio.Button value={DrawTool.pancel}>画笔</Radio.Button>
          <Radio.Button value={DrawTool.bucket}>油漆桶</Radio.Button>
        </Radio.Group>
      </InlineBlock>
      <InlineBlock>
        <Palette
          size={16}
          color={options.get.color}
          onChangeColor={options.set.color}
        />
      </InlineBlock>
      <InlineBlock>
        <Radio.Group size="small" value={options.get.drawMode} onChange={e => options.set.drawMode(e.target.value)} buttonStyle="solid">
          <Radio.Button value={DrawMode.normal}>无</Radio.Button>
          <Radio.Button value={DrawMode.lrs}>左右</Radio.Button>
          <Radio.Button value={DrawMode.uds}>上下</Radio.Button>
          <Radio.Button value={DrawMode.centrosymmetry}>中心</Radio.Button>
        </Radio.Group>
      </InlineBlock>

      <InlineBlock>
        <span><a href="#" onClick={() => setVisible(true)}>预览</a></span>
      </InlineBlock>
      {/* <InlineBlock>
        <span>{options.get.pos.join(',')}</span>
      </InlineBlock> */}
      <Modal
        width="90%"
        visible={visible}
        title="预览"
        onCancel={() => setVisible(false)}
        footer={null}
      >
        {visible && (
          <div>
            <ColorBitMapPreview
              bitMap={colorBitMaps.table.entries[activeBitMapID].map}
              size={10}
            />
            <div>code: <a href="#" onClick={() => {
              copy(JSON.stringify(bitMap2Base64(colorBitMaps.table.entries[activeBitMapID].map), null, 2));
              message.success('复制成功');
            }}>复制</a></div>
            <div
              style={{
                overflow: 'atuo',
                backgroundColor: '#000',
                color: '#fff',
              }}
            >
              <pre>
                {JSON.stringify(bitMap2Base64(colorBitMaps.table.entries[activeBitMapID].map), null, 2)}
              </pre>
            </div>
          </div>
        )}
      </Modal>
    </Container>
  );
}
const S = {
  Container: styled.div`
  	/* position: relative; */
    background-color: #f3f3f3;
    border-top: 1px solid #cbcccc;
    height: 36px;
    font-size: 12px;
    min-width: 840px;
    -webkit-box-shadow: inset 0 1px 0 0 #fff;
    -moz-box-shadow: inset 0 1px 0 0 #fff;
    box-shadow: inset 0 1px 0 0 #fff;
    background-color: #f5f5f5;
    background-image: -webkit-linear-gradient(top,#f5f5f5,#eee);
    background-image: -moz-linear-gradient(top,#f5f5f5,#eee);
    background-image: -ms-linear-gradient(top,#f5f5f5,#eee);
    background-image: -o-linear-gradient(top,#f5f5f5,#eee);
    background-image: linear-gradient(top,#f5f5f5,#eee);
    border-bottom: 1px solid #aaaaaa;
  `,
  InlineBlock: styled.div`
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
  `,
}